// The bell sits in the header and controls the drawer (aria-controls); the toast stack is a live
// region of its own.
export const NOTIFICATION_BELL_ID = 'notificationBell';
export const NOTIFICATION_DRAWER_ID = 'notificationPanel';
export const NOTIFICATION_TOAST_REGION_ID = 'notificationToastRegion';

// Prefix of every bell notification query: invalidating it refreshes the summary and the list.
export const NOTIFICATIONS_QUERY_KEY = 'notifications';
